module.exports = __webpack_public_path__ + "static/img/punch.27bc8e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/punch.png
// module id = SFQN
// module chunks = 1